import remark from 'remark';
import markdown from 'remark-parse';
import remarkHTML from 'remark-html';
import remarkBreaks from 'remark-breaks';

const mdToHtml = value => remark()
                    .use(markdown)
                    .use(remarkHTML)
                    .use(remarkBreaks)
                    .processSync(value)
                    .toString()

export default mdToHtml;